module.exports = __webpack_public_path__ + "img/icon_channel_hot.5f6ec863.png";